/*
 * Module for the Contact Log Follow-Up page
 */
rs.module("content/system_/activity/contactlogfollowup/index", [],

    function () {

        //Initialize the page
        function initialize(lrsGridApi, backendUrl, jsSelectors) {

            //Using onjs() because only visible rows in the grid will have their contents rendered. 
            //Selecting by js selector and adding a click handler would only get click handlers hooked up for the visible rows.
            $(document).onjs('click', jsSelectors.followUpCheckBox, function () {

                var followUpCheckBox = $(this);
         
                if (!followUpCheckBox.is(":checked")) {

                    //Get the rows update spinner and show it
                    var spinner = $(this).siblingsjs(jsSelectors.spinner);
                    spinner.show();

                    //Get the record key (ContactLogCRMKey) associated to the grid row that the checkbox was unchecked
                    var contactLogCrmKey = followUpCheckBox.data("contactlogcrmkey");

                    //Get the row id in the grid associated to the checkbox was unchecked
                    var gridRowId = followUpCheckBox.data("row-id");

                    //Get the physical row Node from the grid API (so we can remove the row later)
                    var rowNode = lrsGridApi.agGridApi.getRowNode(gridRowId);

                    //Make AJAX call to update the contact log record
                    $.post(backendUrl, { contactLogCrmKey: contactLogCrmKey }, "json").done(function (data) {

                        //If the AJAX call to delete succeeded, remove the associated row from the grid
                        if (data === true) {
                            lrsGridApi.agGridApi.applyTransaction({ remove: [rowNode.data] });
                        }
                    }).always(function () {
                        //Hide row's update spinner
                        spinner.hide();
                    });
                }
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);